document.addEventListener("DOMContentLoaded", (event) => {
  const allCourses = Array.from(document.getElementsByClassName("curso-item"));
  const searchInput = document.getElementById("searchQuery");
  const dateInput = document.getElementById("dateQuery");
  const cityInput = document.getElementById("cityQuery");
  const searchButton = document.getElementById("searchButton");
  const resetButton = document.getElementById("resetButton"); // Botón opcional para resetear

  // Función principal de filtrado
  function filterCourses() {
    const searchTerm = (searchInput.value || '').toLowerCase().trim();
    const dateTerm = dateInput.value || '';
    const cityTerm = (cityInput.value || '').toLowerCase().trim();

    // Verificar si todos los filtros están vacíos
    const allFiltersEmpty = !searchTerm && !dateTerm && !cityTerm;

    allCourses.forEach(course => {
      // Obtener datos del curso (con valores por defecto para evitar errores)
      const name = (course.dataset.name || '').toLowerCase();
      const instructor = (course.dataset.instructor || '').toLowerCase();
      const city = (course.dataset.city || '').toLowerCase();
      const date = course.dataset.date || '';

      // Lógica de filtrado
      const matchesSearch = !searchTerm || 
                           name.includes(searchTerm) || 
                           instructor.includes(searchTerm);
      
      const matchesCity = !cityTerm || 
                        city.includes(cityTerm);
      
      const matchesDate = !dateTerm || 
                        date === dateTerm;

      // Mostrar u ocultar según los filtros
      if (allFiltersEmpty || (matchesSearch && matchesCity && matchesDate)) {
        course.style.display = 'block';
      } else {
        course.style.display = 'none';
      }
    });

    // Mostrar mensaje si no hay resultados (opcional)
    //showNoResultsMessage();
  }

  // Función para mostrar mensaje cuando no hay resultados (opcional)
  function showNoResultsMessage() {
    const visibleCourses = allCourses.filter(course => course.style.display !== 'none');
    const noResultsMsg = document.getElementById('no-results-message');
    
    if (visibleCourses.length === 0 && !areAllFiltersEmpty()) {
      if (!noResultsMsg) {
        const msg = document.createElement('div');
        msg.id = 'no-results-message';
        msg.textContent = 'No se encontraron cursos con los filtros aplicados.';
        msg.style.textAlign = 'center';
        msg.style.padding = '20px';
        msg.style.color = 'white';
        document.querySelector('.cursos-grid').appendChild(msg);
      }
    } else if (noResultsMsg) {
      noResultsMsg.remove();
    }
  }

  // Función para verificar si todos los filtros están vacíos
  function areAllFiltersEmpty() {
    return !searchInput.value && !dateInput.value && !cityInput.value;
  }

  // Función para resetear todos los filtros (opcional)
  function resetFilters() {
    searchInput.value = '';
    dateInput.value = '';
    cityInput.value = '';
    filterCourses();
  }

  // Event listeners
  if (searchButton) searchButton.addEventListener('click', filterCourses);
  if (resetButton) resetButton.addEventListener('click', resetFilters);
  
  if (searchInput) {
    searchInput.addEventListener('keyup', function(e) {
      if (e.key === 'Enter') filterCourses();
    });
  }

  if (cityInput) cityInput.addEventListener('change', filterCourses);
  if (dateInput) dateInput.addEventListener('change', filterCourses);

  // Filtrar inicialmente para asegurar estado consistente
  resetFilters();
  filterCourses();
});